import React, {PureComponent} from 'react'
import styled from 'styled-components'
import { WHITE,LIGHT_BLUE } from '../colors';

const StyledInput = styled.input`
    background:rgba(255,255,255,0.05);
    border:none;
    border-bottom: 1px solid ${LIGHT_BLUE};
    height:40px;
    line-height:40px;
    padding:0 10px;
    vertical-align:middle;
    color:${WHITE};
    display:block;
    font-size:15px;
    
`

export default class TextInput extends PureComponent{
    render(){
        let type = this.props.text || 'text'
        return <StyledInput {...this.props} type={type} />
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/textInput.js